import { apiClient } from './apiClient';

export interface UserDashboard {
  inProgress: number;
  dueSoon: number;
  overdue: number;
  completedThisWeek: number;
  pendingSignatures: number;
  chart7Days: Array<{ date: string; count: number }>;
  todayTasks: Array<{
    id: string; code: string; title: string;
    status: string; priority: string; dueDate: string;
  }>;
  pendingSigList: Array<{
    id: string; documentName: string; createdAt: string;
    dueDate?: string; requesterName?: string;
    /** V1.0.60: Mô tả/yêu cầu ký từ người gửi */
    taskDescription?: string;
  }>;
}

export interface DepartmentDashboard {
  departmentId: string;
  departmentCode: string;
  departmentName: string;
  staffCount: number;
  openTasks: number;
  completedTasks: number;
  overdueTasks: number;
  dueSoonTasks: number;
  /** V1.0.34 H3: Số task khoa là chủ quản */
  primaryTasks?: number;
  /** V1.0.34 H3: Số task khoa hỗ trợ (có assignee từ khoa nhưng không chủ quản) */
  supportingTasks?: number;
  distribution: Array<{ category: string; count: number }>;
  workload: Array<{
    userId: string; fullName: string;
    totalOpen: number; onTrack: number; warning: number; late: number;
  }>;
  overdueList: Array<{
    id: string; code: string; title: string;
    assigneeName?: string; dueDate: string; daysOverdue: number;
    /** V1.0.34 H3: TRUE = khoa là chủ quản; FALSE = khoa đang hỗ trợ */
    isPrimary?: boolean;
  }>;
}

export interface ExecutiveDashboard {
  openTasksTotal: number;
  completedTasksTotal: number;
  overdueTasksTotal: number;
  completedThisMonth: number;
  totalUsers: number;
  totalDepartments: number;
  overallCompletionRate: number;
  departmentStats: Array<{
    id: string; code: string; name: string;
    staffCount: number; openTasks: number; completedTasks: number;
    overdueTasks: number; completionRate: number;
  }>;
  trend30Days: Array<{ date: string; created: number; completed: number }>;
}

export const dashboardService = {
  async user(): Promise<UserDashboard> {
    const { data } = await apiClient.get<UserDashboard>('/dashboard/user');
    return data;
  },

  async department(departmentId?: string): Promise<DepartmentDashboard> {
    const params = departmentId ? { departmentId } : undefined;
    const { data } = await apiClient.get<DepartmentDashboard>('/dashboard/department', { params });
    return data;
  },

  async executive(): Promise<ExecutiveDashboard> {
    const { data } = await apiClient.get<ExecutiveDashboard>('/dashboard/executive');
    return data;
  },
};
